<template>
  <div class="AssociationArticles wow bounceInUp">
    <div class="cont">
      <ComTitlte titleEn="CONSTITUTION " titleZh="协会章程"></ComTitlte>
      <div class="main">
        <div class="swiper-button-prev"></div>
        <div class="imgList">
          <div
            class="swiper-container"
            v-swiper:AssociationArticlesSwiper="swiperOption"
          >
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in imgList" :key="item.id">
                <div class="bannerImg">
                  <img
                    class="banner_bg"
                    :src="item.imageUrl"
                    :alt="item.imageName"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
// import Swiper from "swiper";
export default {
  name: "AssociationArticles",
  data() {
    return {
      imgList: [],
      imgBaseUrl: "",
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoResize: true,
        watchActiveIndex: true,
        lazyLoading: true, // 图片懒加载
        lazyLoadingInPrevNext: true,
        preventLinksPropagation: false,
        preventClicks: false,
        visibilityFullFit: true,
        updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swipe
        calculateHeight: true, // 当值为true时，
        slidesPerView: 1,
        autoplay: 3000,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  created() {
    this.getImageManageList();
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
    // this.swiper_AssociationArticles = new Swiper(
    //   ".swiper_AssociationArticles",
    //   {
    //     observer: true, //修改swiper自己或子元素时，自动初始化swiper
    //     observeParents: true, //修改swiper的父元素时，自动初始化swiper
    //     autoResize: true,
    //     watchActiveIndex: true,
    //     lazyLoading: true, // 图片懒加载
    //     lazyLoadingInPrevNext: true,
    //     preventLinksPropagation: false,
    //     preventClicks: false,
    //     visibilityFullFit: true,
    //     updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swipe
    //     calculateHeight: true, // 当值为true时，
    //     slidesPerView: 1,
    //     loop: true,
    //   }
    // );
    // this.$refs.indexDetailimgSwiper.swiperSl.swipeNext();
  },
  methods: {
    // 图片获取方式
    async getImageManageList() {
      this.imgBaseUrl = this.$store.state.baseUrl;
      for (let i = 1; i <= 16; i++) {
        this.imgList.push({
          id: "Articles" + i + 1,
          imageUrl: "/Articles/" + i + ".jpg",
          imageName: "Articles" + i,
        });
      }
      // let organData = await this.$request.getImageManageList({
      //   columnType: "55",
      // });
      // if (organData.code == 200) {
      //   this.imgList = organData.rows;
      //   this.imgBaseUrl = this.$store.state.baseUrl;
      // }
    },
  },
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.AssociationArticles {
  background-size: cover;
  position: relative;
}
.cont {
  width: $themeMinWidth;
  margin: 40px auto 0;
  position: relative;
  z-index: 6;
  background: #fff;
  box-sizing: border-box;
  padding: 10px 20px 40px 20px;
  border: solid 1px #e3e3e3;
  &::before {
    content: "";
    display: block;
    width: 33px;
    height: 15px;
    background: url("../../assets/img/common/icon_sanjiao.png") top center
      no-repeat;
    background-size: cover;
    position: absolute;
    top: -13px;
    left: 700px;
    z-index: 66;
  }
  .main {
    padding: 50px 0 0 0;
    .swiper-button-prev {
      width: 58px;
      height: 58px;
      background: url("../../assets/img/company/swiper-button-prev.png") top
        center no-repeat;
      background-size: cover;
      &::after {
        display: none;
      }
    }
    .swiper-button-next {
      width: 58px;
      height: 58px;
      background: url("../../assets/img/company/swiper-button-next.png") top
        center no-repeat;
      background-size: cover;
      &::after {
        display: none;
      }
    }
    .imgList {
      width: 516px;
      margin: 0 auto 0;
      padding: 20px 0 30px 0;
      box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.19);

      /deep/ .bannerImg {
        width: 516px;
        height: 730px;
        img {
          display: block;
          width: 516px;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
